import React, { useEffect } from "react"

import { connect } from "react-redux";
import {
  Row,
  Col,
} from "reactstrap"

// Pages Components
import Miniwidget from "./Miniwidget"
import MonthlyEarnings from "./montly-earnings";
import EmailSent from "./email-sent";
import MonthlyEarnings2 from "./montly-earnings2";
import Inbox from "./inbox";
import RecentActivity from "./recent-activity";
import WidgetUser from "./widget-user";
import YearlySales from "./yearly-sales";
import LatestTransactions from "./latest-transactions";
import LatestOrders from "./latest-orders";

//Import Action to copy breadcrumb items from local state to redux state
import { setBreadcrumbItems } from "../../store/actions";

import AdminDashboard from "./Admin/AdminDashboard"
import SalesDashboard from "./Admin/SalesDashboard"
import CompanyDashboard from "./Company/CompanyDashboard"

const Dashboard = (props) => {
  // Get user role from localStorage
  const authUser = JSON.parse(localStorage.getItem("authUser"));
  const userRole = (authUser && authUser.user && authUser.user.all_roles && authUser.user.all_roles.length > 0)
    ? authUser.user.all_roles[0].slug
    : "";

  const isSystemRole = ["super-admin", "admin", "support", "sales"].includes(userRole);

  document.title = "Dashboard | CRM SaaS";

  const breadcrumbItems = [
    { title: "CRM", link: "#" },
    { title: "Dashboard", link: "#" }
  ]

  useEffect(() => {
    props.setBreadcrumbItems('Dashboard', breadcrumbItems)
  }, [])

  const getDashboard = () => {
    switch (userRole) {
      case "super-admin":
      case "admin":
      case "support":
        return <AdminDashboard />
      case "sales":
        return <SalesDashboard />
      default:
        return <CompanyDashboard />
    }
  }

  return (
    <React.Fragment>
      {getDashboard()}
    </React.Fragment>
  )
}

export default connect(null, { setBreadcrumbItems })(Dashboard);